import { render, staticRenderFns } from "./sharing-levels.vue?vue&type=template&id=0230e1a8"
import script from "./sharing-levels.vue?vue&type=script&lang=js"
export * from "./sharing-levels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports